import { gql } from "graphql-request";

const SERVER_DELETE_PAYMENT_METHOD = gql`
  mutation SERVER_DeletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id)
  }
`;
export default SERVER_DELETE_PAYMENT_METHOD;
